import React from 'react';
import { ComponentWrapper, ComponentVerticalSpacing } from 'day8-react/build/new-components';
import PageLayout from '../layouts/page';

const FullLegal = () => (
  <PageLayout page={{ seo_title: 'Legal | The Ski Week' }}>
    <ComponentVerticalSpacing>
      <ComponentWrapper>
        <div className="top-title text-center max-width-xs margin-auto text-component">
          <span className="d8-u-color-primary d8-u-ls-sm d8-u-text-bold">OUR COMPANY</span>
          <h1>Legal</h1>
          <p className="margin-top-xl">
            We are The Ski Week Ltd, a company registered in the United Kingdom
            with the number 9116193, and trading as “The Ski Week”. We own and
            operate this website (&apos;Site&apos;).
          </p>
          <p>
            Your use of the Site is subject to these Terms of Use. By using the
            Site, you will be deemed to have accepted and agreed to be bound by
            these Terms of Use. We may make changes to these Terms of Use from
            time to time. We will notify you of such changes by posting the
            revised version of these Terms of Use on the Site. You can determine
            when we last changed these Terms of Use by referring to the ‘LAST
            UPDATED’ statement above. Your use of the Site following changes to
            these Terms of Use will constitute your acceptance of those changes.
          </p>
          <p>
            You are responsible for all access to the Site using your Internet
            connection, even if the access is by another person.
          </p>
          <p>
            We reserve the right to restrict your access to the Site or part of
            it. Access to restricted areas of the Site may be subject to
            registration and other conditions. If we grant you permission to
            access a restricted area, we may withdraw that permission at any
            time (including where you breach any of these Terms of Use).
          </p>
          <p>
            We will use reasonable efforts to ensure that the Site is available
            at all times. However, we cannot guarantee that the Site or any
            individual function or feature of the Site will always be available
            and/or error free. In particular, the Site may be unavailable during
            periods when we are implementing upgrades to or carrying out
            essential maintenance on the Site.
          </p>
          <p>
            The intellectual property rights in the Site and all of the text,
            pictures, videos and other content made available on it are owned by
            us and our licensors. You may not print or otherwise make copies of
            any such content without our express prior permission.
          </p>
          <p>
            We provide the Site on an ‘as is’ basis and make no representations
            as to the quality, completeness or accuracy of any content made
            available on the Site. To the maximum extent permitted by law, we
            expressly exclude:
            <ol>
              <li>
                all conditions, warranties and other terms that might otherwise
                be implied by law into these Terms of Use; and
              </li>
              <li>
                any and all liability to you, whether arising under these Terms
                of Use or otherwise in connection with your use of the Site.
              </li>
            </ol>
            The foregoing is a comprehensive limitation of liability that
            applies to all damages of any kind, including (without limitation)
            compensatory, direct, indirect or consequential damages, loss of
            data, income or profit, loss of or damage to property and claims of
            third parties. Notwithstanding the foregoing, nothing in these Terms
            of Use is intended to exclude or limit any liability that may not by
            law be excluded or limited, and in particular none of the exclusions
            and limitations in this clause are intended to limit any rights you
            may have as a consumer or other statutory rights which may not be
            excluded, nor in any way to exclude or limit (site owner) liability
            to you for death or personal injury resulting from our negligence or
            that of our employees or agents.
          </p>
          <p>
            Your permission to use the Site is personal to you and
            non-transferable, and you may not use the Site for commercial
            purposes. Your use of the Site is conditional on your compliance
            with the rules of conduct set forth in these Terms of Use and you
            agree that you will not:
            <ol>
              <li>use the Site for any fraudulent or unlawful purpose;</li>
              <li>
                use the Site to defame, abuse, harass, stalk, threaten or
                otherwise violate the rights of others, including without
                limitation others’ privacy rights or rights of publicity;
              </li>
              <li>
                impersonate any person or entity, falsely state or otherwise
                misrepresent your affiliation with any person or entity in
                connection with the Site; or express or imply that we endorse
                any statement you make;
              </li>
              <li>
                interfere with or disrupt the operation of the Site or the
                servers or networks used to make the Site available; or violate
                any requirements, procedures, policies or regulations of such
                networks;
              </li>
              <li>
                transmit or otherwise make available in connection with the Site
                any virus, worm, Trojan horse or other computer code that is
                harmful or invasive or may or is intended to damage the
                operation of, or to monitor the use of, any hardware, software,
                or equipment;
              </li>
              <li>
                reproduce, duplicate, copy, sell, resell, or otherwise exploit
                for any commercial purposes, any portion of, use of, or access
                to the Site;
              </li>
              <li>
                modify, adapt, translate, reverse engineer, decompile or
                disassemble any portion of the Site. If you wish to reverse
                engineer any part of the Site to create an interoperable program
                you must contact us and we may provide interface data subject to
                verification of your identity and other information;
              </li>
              <li>
                remove any copyright, trade mark or other proprietary rights
                notice from the Site or materials originating from the Site;
              </li>
              <li>
                frame or mirror any part of the Site without our express prior
                written consent;
              </li>
              <li>
                create a database by systematically downloading and storing Site
                content;
              </li>
              <li>
                use any manual or automatic device in any way to gather Site
                content or reproduce or circumvent the navigational structure or
                presentation of the Site without our express prior written
                consent. Notwithstanding the foregoing, we grant the operators
                of public online search engines limited permission to use search
                retrieval applications to reproduce materials from the Site for
                the sole purpose of and solely to the extent necessary for
                creating publicly available searchable indices of such materials
                solely in connection with each operator’s public online search
                service. We reserve the right to revoke these exceptions either
                generally or in specific instances.
              </li>
              <li>
                The Site may provide links to other websites and online
                resources. We are not responsible for and do not endorse such
                external sites or resources. Your use of third party websites
                and resources is at your own risk.
              </li>
            </ol>
          </p>
          <p>
            All information on the Site is subject to change without notice and
            without warranty.
          </p>
          <p>
            The Site may contain links to other websites or may frame material
            from other websites. Such material has been created by or for the
            respective owners of those websites and is not under our control. We
            have not undertaken to verify the truth or accuracy of any such
            material and make no representation or warranty with respect to any
            such content.
          </p>
          <p>
            The information and prices shown on the Site are updated from time
            to time and therefore may have changed by the time you come to book
            your charter or service. Although we make every effort to ensure the
            accuracy of all such information and prices, errors do occasionally
            occur. Therefore, you must ensure all details of your booking
            (including price) at the time of booking. We can accept no liability
            for changes in such information and/or price.
          </p>
          <p>
            Please refer to our Booking Terms and Conditions for further
            information on the terms governing bookings made through the Site.
          </p>
        </div>
      </ComponentWrapper>
    </ComponentVerticalSpacing>
  </PageLayout>
);

export default FullLegal;
